<template>
	<div @click="getSelectedResources" class="resource-vs-list-item">
		<vs-list-item :title="resource_local.username" :subtitle="fullname">
			<template slot="avatar">
				<vs-avatar @click="getSelectedResources" />
			</template>
			<calendar-icon v-if="resource_local.id === currentResourceId" size="2.5x" color="#28c76f"></calendar-icon>
		</vs-list-item>
	</div>
</template>
<script>
import {BatteryChargingIcon, BatteryIcon, WifiIcon, CalendarIcon} from "vue-feather-icons";

export default {
	components: {
		BatteryChargingIcon,
		BatteryIcon,
		WifiIcon,
		CalendarIcon,
	},
	props: {
		resource: {
			type: Object,
		},
	},
	data: () => ({
		title: "hello",
	}),
	computed: {
		resource_local() {
			return this.resource;
		},
		fullname() {
			return `${this.resource_local.name} ${this.resource_local.lastname}`;
		},
		currentResourceId() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource.hasOwnProperty("id")) {
				return currentResource.id;
			} else {
				return 0;
			}
		},
	},
	methods: {
		getSelectedResources() {
			this.$store.dispatch("moduleSchedule/selectedResource", this.resource_local);
		},
	},
};
</script>
<style scoped>
.resource-vs-list-item {
	cursor: pointer;
}
</style>
